/**
 * Bouwt een schema.org `FAQPage` JSON-LD script-tag voor gebruik in
 * TanStack Start `head().scripts`. Google vereist dat de FAQ-inhoud
 * ook zichtbaar op de pagina staat — gebruik dezelfde items voor
 * zowel deze helper als de zichtbare accordeon.
 */
export type FaqItem = { q: string; a: string };

export function faqPageJsonLd(items: FaqItem[], id?: string) {
  const data: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  if (id) data["@id"] = id;
  return {
    type: "application/ld+json" as const,
    children: JSON.stringify(data),
  };
}
